



















import { computed, defineComponent, watch } from '@nuxtjs/composition-api';
import useMyGarage from '@shared/composables/useMyGarage';
import useResponsive from '@shared/composables/useResponsive';
import useToggleState from '@shared/composables/useToggleState';
import useVehiclesSidebar from '@shared/composables/useVehiclesSidebar';
import { VehicleSidebarState } from '@shared/system-constants';
import { UCAppHeaderItem, UCBadge } from '@shared/ui';
import clickOutside from 'vue-click-outside';

import { Dropdown } from '~/components/AppHeader/constants';
import DropdownGarage from '~/components/AppHeader/DropdownGarage.vue';

export default defineComponent({
  name: 'HeaderGarage',
  components: {
    DropdownGarage,
    UCAppHeaderItem,
    UCBadge,
  },
  directives: {
    clickOutside,
  },
  setup() {
    const { selectedVehicle, vehicles, getFormattedTitleTiny } = useMyGarage();
    const {
      state: dropdownOpen,
      setValue: setDropdownOpen,
      toggle: toggleDropdown,
    } = useToggleState(Dropdown.Garage);
    const { open: openSidebar } = useVehiclesSidebar();
    const { isMobile } = useResponsive();

    const editVehicle = () => {
      openSidebar(VehicleSidebarState.GARAGE);
    };

    const onCloseDropdown = () => {
      setDropdownOpen(false);
    };

    const onClick = () => {
      if (!isMobile.value && vehicles.value?.length) {
        toggleDropdown();
      } else {
        openSidebar(vehicles.value?.length ? VehicleSidebarState.GARAGE : undefined);
      }
    };

    const onClickOutside = () => {
      setDropdownOpen(false);
    };

    const title = computed(() => (isMobile.value ? 'Garage' : 'My Garage'));

    watch(isMobile, (val) => {
      if (val) setDropdownOpen(false);
    });

    return {
      title,
      dropdownOpen,
      selectedVehicle,
      onClick,
      editVehicle,
      onClickOutside,
      onCloseDropdown,
      getFormattedTitleTiny,
    };
  },
});
